import React, { useState } from 'react';
import { certificationsData } from '../../data/CertificateData.js';
import ProductDrawer from '../layout/ProductDrawer.jsx'; // Adjust path based on your file structure

export default function CertificationsSection() {
  const [activeCertificate, setActiveCertificate] = useState(null);

  return (
    <section className="bg-slate-50 py-16 lg:py-24" aria-labelledby="certifications-title">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <header className="text-center max-w-3xl mx-auto mb-16 space-y-3">
         
          <h2 id="certifications-title" className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            {certificationsData.heading}
          </h2>
          <p className="text-base text-slate-600 font-normal leading-relaxed">
            {certificationsData.description}
          </p>
        </header>

        {/* Simplified Cards List */}
        <div className="space-y-12 lg:space-y-16">
          {certificationsData.items.map((item) => (
            <article 
              key={item.id} 
              className="bg-white rounded-xl p-6 lg:p-8 border border-slate-200"
            >
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                
                {/* Image Wrapper */}
                <div className={`h-[240px] sm:h-[300px] lg:h-[360px] rounded-lg overflow-hidden bg-slate-100 p-6 sm:p-8 lg:p-10 flex items-center justify-center ${
                  item.reverse ? 'lg:order-2' : 'lg:order-1'
                }`}>
                  <img 
                    src={item.image} 
                    alt={item.altText} 
                    className="max-w-full max-h-full w-auto h-auto object-contain object-center" 
                    loading="lazy"
                  />
                </div>
                
                {/* Content */}
                <div className={`space-y-5 ${item.reverse ? 'lg:order-1' : 'lg:order-2'}`}>
                  <div>
                    <span className="inline-flex items-center text-xs font-semibold tracking-wider text-emerald-700 bg-emerald-50 px-2.5 py-0.5 rounded border border-emerald-100">
                      {item.badge}
                    </span>
                    <h3 className="mt-2 text-xl lg:text-2xl font-bold text-slate-900">
                      {item.title}
                    </h3>
                  </div>
                  
                  <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
                    {item.description}
                  </p>
                  
                  <ul className="space-y-2" role="list">
                    {item.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center space-x-2.5 text-slate-700 text-sm">
                        <svg className="h-5 w-5 text-blue-600 shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
                        </svg>
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  
                  <div className="pt-1">
                    <button 
                      type="button"
                      onClick={() => setActiveCertificate({
                        title: item.title,
                        img: item.image,
                        alt: item.altText
                      })}
                      className="inline-flex items-center justify-center px-5 py-2 rounded-lg border border-slate-300 text-slate-700 font-medium text-sm bg-white hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2 transition-colors duration-150 cursor-pointer"
                    >
                      <span>View Certificate</span>
                      <svg className="ml-1.5 h-4 w-4" fill="none" viewBox="0 0 24 24" strokeWidth="2.5" stroke="currentColor" aria-hidden="true">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                      </svg>
                    </button>
                  </div>
                </div>

              </div>
            </article>
          ))}
        </div>

      </div>

      {/* Full View Product Drawer Overlay */}
      {activeCertificate && (
        <ProductDrawer 
          product={activeCertificate} 
          onClose={() => setActiveCertificate(null)} 
        />
      )}
    </section>
  );
}